module.exports = __webpack_public_path__ + "static/media/orgStructureRequest.2ef0bb8f.svg";